import React from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import BrandCard from '../Card/BrandCard'

const RedirectingSkeleton: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div aria-label="redirecting-skeleton">
      <BrandCard
        minimumScreenHeight={510}
        cardContent={
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ py: 4 }}
          >
            <Skeleton variant="circular" width={40} height={40} />
            <Typography variant="body1" sx={{ mt: 2 }}>
              {t('RedirectingSkeleton.Message', 'Redirecting…')}
            </Typography>
          </Box>
        }
      />
    </div>
  )
}

export default RedirectingSkeleton
